import { tns } from './tiny-slider';

const sharedSliderOpts = {
  items: 1,
  gutter: 20,
  controls: false,
  responsive: {
    768: {
      items: 2,
    },
    1280: {
      items: 3,
    },
  },
  slideBy: 'page',
  mouseDrag: true,
  swipeAngle: false,
  center: false,
  loop: false,
  speed: 400,
};

tns({
  container: '.announcements .content-section__slider',
  ...sharedSliderOpts,
});

tns({
  container: '.in-the-press .content-section__slider',
  ...sharedSliderOpts,
});

// handle download all solv svgs
const download = document.querySelector('#download-logos');
const logos = document.querySelectorAll('.logos a.resources__download-image');
download.addEventListener('click', () => {
  logos.forEach((element) => {
    element.click();
  });
});
